export const IMAGE_TYPES = {
  VIDEO: "video",
  COLOR: "color",
  GRADIENT: "gradient",
  UNSPLASH: "unsplash",
  LINK: "link",
  ATTACHMENTS: "attachments",
  LIBRARY: "library",
};
